import React from 'react'
import styled from 'styled-components'
import { Flex, ResponsiveSVG } from 'ui/acro'
import Lock from '../../../../../assets/images/lock.svg'
import Unlock from '../../../../../assets/images/unlock.svg'
import { ALO_ACCESS, PREMIUM, LIMITED, isAloAccessType } from './constants'

const Container = styled(Flex)`
  background-color: ${({ variant }) =>
    [ALO_ACCESS, LIMITED].includes(variant) ? '#D6C7B3' : '#3A3A39'};
  color: ${({ variant }) =>
    [ALO_ACCESS, LIMITED].includes(variant) ? '#000' : '#FFF'};
  padding: 4px 8px;
  justify-content: flex-end;
  align-items: center;
  gap: 2px;
  font-family: 'Proxima-Nova';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;

  border-radius: 12px;
  position: absolute;
  right: ${(props) => props.right ?? '5px'};
  bottom: ${(props) => props.bottom ?? '5px'};

  svg {
    fill: ${({ variant }) =>
      [ALO_ACCESS, LIMITED].includes(variant) ? '#000' : '#fff'};
    width: 24px;
    height: 24px;
  }
`

const AccessIdentifier = ({
  availabilityGating,
  isGridView,
  membershipTier,
  rightPosition,
  bottomPosition
}) => {
  const identifierLabel = {
    ALO_ACCESS: 'ALO Access',
    LIMITED: 'Limited',
    PREMIUM: 'Premium'
  }[availabilityGating]

  if (!availabilityGating) return null
  if (![ALO_ACCESS, PREMIUM, LIMITED].includes(availabilityGating)) return null

  return (
    <Container
      variant={availabilityGating}
      right={rightPosition}
      bottom={bottomPosition}
      {...(isGridView && { style: { padding: '4px' } })}
    >
      <ResponsiveSVG
        SVG={
          availabilityGating === 'LIMITED' && isAloAccessType(membershipTier)
            ? Unlock
            : Lock
        }
        width='14px'
        height='14px'
      />
      {!isGridView && <>{identifierLabel}</>}
    </Container>
  )
}
export default AccessIdentifier
